// import { PayPalEnvironment } from 'ngx-paypal';

export const environment = {
  //**Dev Setting */
  production: false,
  turnstileSiteKey: '0x4AAAAAACaKGwDqVfcUCk5J',
  storeAdmin_InksoftDesignUrl: 'https://dev-api.merchloop.com/store/customizedproducts?designID=0',
  frontEnd_BaseUrl: 'https://dev.merchloop.com/',
  baseUrl: 'https://dev-api.merchloop.com',
  imgBaseURL: 'https://stores.inksoft.com',
  // Stored image paths are absolute Azure Blob URLs post-migration; no host prefix needed.
  masterProductImgBaseURL: '',
  api_url_inksoft: 'https://stores.inksoft.com/DS304263396/Api2',
  baseUrlShopifyApp: 'https://dev-app.merchloop.com',
  paypalPublicKey: 'AXtEiqfEBw-aEWdVAxVkUbzWBZTDXHi5BF9XS-dOC0emxWOpqlLenLYIaRNcBobFssZ9fvcQmrCUmHVC',
  // paypalEnv: PayPalEnvironment.Sandbox,
  prod: false,
  productCustomImageFolder: 'https://stokedmanagementdiag.blob.core.windows.net/stagingcustomproductimages/',
  warehouseProductCustomImageFolder: 'https://stokedmanagementdiag.blob.core.windows.net/stagingwarehouseproductimages/',
  assignOrderlog: 'https://stokedmanagementdiag.blob.core.windows.net/stagingassignorderlog/',
  azureBlobCdnUrl: 'https://stokedmanagementdiag.blob.core.windows.net/',
  huddleLogoFolder: 'https://stokedmanagementdiag.blob.core.windows.net/staginghuddlelogo/',
  huddleBackgroundFolder: 'https://stokedmanagementdiag.blob.core.windows.net/staginghuddlebackground/',
  // Design Huddle Integration
  designHuddleEnabled: true,
  designHuddleEditorUrl: 'https://editor.designhuddle.com',
  designHuddleDomain: 'merchloop.designhuddle.com',
  designHuddleClientId: 'wq80d0zhhn6xkvfjofl3',
  designHuddleCategoryId: 4,
  // Customer Portal API
  customerPortalApiUrl: 'https://customerportal-customerportalapi-ameedfdfgyayh5ax.northcentralus-01.azurewebsites.net',
};
